// Locale code (e.g. "sv-SE", "en-gb") → Google Translate language code.
const toGoogleLang = (code: string): string => {
  const lower = code.toLowerCase();
  // Special cases where the full tag matters
  if (lower === "zh-tw") return "zh-TW";
  if (lower === "zh-cn") return "zh-CN";
  // For most locales the bare language subtag works fine
  return lower.split("-")[0];
};

export const googleTranslate = async (
  text: string,
  sourceLocale: string,
  targetLocale: string
): Promise<string> => {
  if (!text.trim()) return "";
  const sl = toGoogleLang(sourceLocale);
  const tl = toGoogleLang(targetLocale);
  if (sl === tl) return text;

  const url = new URL("https://translate.googleapis.com/translate_a/single");
  url.searchParams.set("client", "gtx");
  url.searchParams.set("sl", sl);
  url.searchParams.set("tl", tl);
  url.searchParams.set("dt", "t");
  url.searchParams.set("q", text);

  const res = await fetch(url.toString());
  if (!res.ok) throw new Error(`Translation failed: ${res.status}`);
  const data = await res.json();

  // Response shape: [[["translated","original",…], …], …]
  // Concatenate all translated segments.
  const segments: string[][] = data?.[0] ?? [];
  return segments.map((seg: string[]) => seg[0] ?? "").join("");
};
